import React from "react";
import { Container } from "@mui/material";
import OrderDetails from "../../../AdminEventView/EventOrders/OrderDetails";

/**
 * Org-level wrapper for OrderDetails. Provides a Container so the order
 * details layout matches the org Orders list when viewed from /orders/:orderId.
 * (Event view uses OrderDetails directly inside its own layout.)
 */
export default function OrderDetailsPage() {
  return (
    <Container>
      <OrderDetails />
    </Container>
  );
}
